import { render, staticRenderFns } from "./riskkarsilastirmaraporu.vue?vue&type=template&id=700d21fc"
import script from "./riskkarsilastirmaraporu.vue?vue&type=script&lang=js"
export * from "./riskkarsilastirmaraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports